

precision highp float;
precision highp sampler2D;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

in vec3 position;
in vec2 uv;

uniform vec2 tex0xy;
uniform vec2 tex1xy;
uniform float tex0size;
uniform float tex1size;
out vec2 tex0coord;
out vec2 tex1coord;
out vec2 mercCoord;

void main()	{
  tex0coord = tex0xy + uv * tex0size;
  tex1coord = tex1xy + uv * tex1size;
  mercCoord = (modelViewMatrix * vec4(position, 1.0)).xy * vec2(1.0, -1.0);
  gl_Position =
    projectionMatrix *
    modelViewMatrix *
    vec4(position,1.);
}